<template>
  <div style="height: 100%">
    <sh-card card-height="100%" card-width="100%">
      <sh-empty-state
        icon="error"
        icon-color="red"
        label="This page no longer exists or was moved to another location."
      >
      </sh-empty-state>
    </sh-card>
  </div>
</template>
